import React from "react";
import { useQuery } from "react-query";
import Slider from "react-slick";
import "../../assets/vendor/slick-master/slick/slick.scss";
import "../../assets/vendor/slick-master/slick/slick-theme.scss";
import TitleGroup, {
  Title,
  SeeAllButton,
} from "../../components/common/TitleGroup";
import OfferCard from "../../components/OfferCard";
import { ApiNames, fetchData } from "../../remote-data/fetchData";
import FakeApiEnabled, { OfferSearch } from "../../fakeapi";
import { usePosition } from "../../components/common/getLocation";
import { settingsOffers } from "./_settings";
import routes from "../../constants/routes";

function Offers() {
  // TODO pass and check position in parent component
  const { position } = usePosition();
  // console.log(position);

  const { data: postData, isLoading: isPostLoading } = useQuery(
    position && ApiNames.SUBMERCHANT_LIST,
    () =>
      fetchData(ApiNames.SUBMERCHANT_LIST, {
        // pathValues: [props.spaceId],
        params: {
          size: 5,
          // latitude: 27.7032021,
          latitude: position.coords.latitude,
          // longitude: 85.3204706,
          longitude: position.coords.longitude,
          next: 0,
          opennow: 3,
          hasOffers: 3,
        },
      })
  );

  const dataObj = "subMerchants";

  if (!position || !postData || isPostLoading) return null;
  //   return <Loader className="position-absolute h-0" />;

  // if (isPostLoading || !postData) return <Loader />;

  //   console.log(postData && postData.data.subMerchants);
  return (
    <>
      {position && postData.data[dataObj].length !== 0 && (
        <div className="nearby-offers">
          <TitleGroup>
            <Title title={"Nearby Merchants"} />
            <SeeAllButton link={`${routes["merchants"]}?nearby=true`} />
          </TitleGroup>

          <Slider className="" {...settingsOffers}>
            {postData
              ? postData.data[dataObj].map((item) => (
                  <div key={item.id}>
                    {/* <OfferCard postItem={item} /> */}

                    <OfferCard
                      cardType="sub-merchant"
                      postItem={{
                        ...item,
                        id: item.id,
                        title: item.name,
                        artwork: item.cover,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        dealDiscount: item.offer && item.offer.dealDiscount,
                        dealType: item.offer && item.offer.dealType,
                        // subMerchants: {}
                      }}
                    />
                  </div>
                ))
              : FakeApiEnabled &&
                OfferSearch.data.offers.map((item) => (
                  <div key={item.id}>
                    <OfferCard postItem={item} />
                  </div>
                ))}
          </Slider>
        </div>
      )}
    </>
  );
}

export default Offers;
